const prefix = <const T extends string>(id: T) => `CardApplication.${id}` as const

const autoCompleteFields = <const T extends string>(id: T) =>
  ({
    Prefix: prefix(id),
    AutoCompleteText: prefix(`${id}#AutoCompleteText`),
    Street1: prefix(`${id}#Street1`),
    Street2: prefix(`${id}#Street2`),
    City: prefix(`${id}#City`),
    State: prefix(`${id}#State`),
    ZipCode: prefix(`${id}#ZipCode`),
  }) as const

export type CardApplicationE2EUser = {
  Email: string
  FirstName: string
  LastName: string
  PhoneNumber: string
}

export const Config = {
  Users: {
    General: {
      Email: '52406b00-3bbb-463c-81d8-297f137bb4b8@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Card Application General',
      PhoneNumber: '(524) 600-3463',
    } as const satisfies CardApplicationE2EUser,
    ManualReview: {
      Email: '56263968-99df-47f1-9e8e-f2bf9e9713bc@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Card Application Manual Review',
      PhoneNumber: '(562) 639-6899',
    } as const satisfies CardApplicationE2EUser,
  },
  Ids: {
    Press: {
      Apply: prefix('Press.Apply'),
      BackButton: prefix('Press.BackButton'),
      GetStartedBack: prefix('Press.GetStartedBack'),
      GetStartedContinue: prefix('Press.GetStartedContinue'),
      OfferCodeBack: prefix('Press.OfferCodeBack'),
      OfferCodeContinue: prefix('Press.OfferCodeContinue'),
      FindHomeBack: prefix('Press.FindHomeBack'),
      FindHomeContinue: prefix('Press.FindHomeContinue'),
      LastQuestionsBack: prefix('Press.LastQuestionsBack'),
      LastQuestionsContinue: prefix('Press.LastQuestionsContinue'),
      ReviewBack: prefix('Press.ReviewBack'),
      ReviewContinue: prefix('Press.ReviewContinue'),
      CardHolderAgreementBack: prefix('Press.CardHolderAgreementBack'),
      InReviewReturnHome: prefix('Press.InReviewReturnHome'),
      CardApplicationStatusBanner: prefix('Press.CardApplicationStatusBanner'),
    },
    View: {
      CardBenefits: prefix('Main.Card.Benefits'),
      FindYourHome: prefix('View.FindYourHome'),
      InReview: prefix('View.InReview'),
    },
    Text: {
      OfferCodeStatus: prefix('Text.OfferCodeStatus'),
    },
    Switch: {
      MailingAddressDifferent: prefix('Switch.MailingAddressDifferent'),
      ConsentToTerms: prefix('Switch.ConsentToTerms'),
    },
    Input: {
      FirstName: prefix('Input.FirstName'),
      LastName: prefix('Input.LastName'),
      PhoneNumber: prefix('Input.PhoneNumber'),
      Email: prefix('Input.Email'),
      OfferCode: prefix('Input.OfferCode'),
      PrimaryAddress: autoCompleteFields('Input.PrimaryAddress'),
      MailingAddress: autoCompleteFields('Input.MailingAddress'),
      DateOfBirth: prefix('Input.DateOfBirth'),
      SSN: prefix('Input.SSN'),
      TotalAnnualIncome: prefix('Input.TotalAnnualIncome'),
      MonthlyHousingPayment: prefix('Input.MonthlyHousingPayment'),
    },
  },
} as const
